import { InjectionToken } from '@angular/core';

export interface UnleashConfiguration {
  url: string;
  clientKey: string;
  appName: string;
  environment: string;
}

export const UNLEASH_CONFIGURATION = new InjectionToken<UnleashConfiguration>('UNLEASH_CONFIGURATION');

export type FeatureFlagToggles = ReleaseFeatureFlagToggles | KillswitchFeatureFlagToggles;

export type ReleaseFeatureFlagToggles =
  | 'show-search-in-filters-for-nested-filters'
  | 'show-mobile-bottom-bar'
  | 'show-self-service'
  | 'show-address-book-rating'
  | 'show-send-business-card';

export type KillswitchFeatureFlagToggles =
  | 'kill-hall-plan'
  | 'kill-newsfeed'
  | 'kill-watchlist'
  | 'kill-search'
  | 'kill-program'
  | 'kill-qrcode-scanner';

export type FeatureFlagToggleList = {
  [key in FeatureFlagToggles]?: boolean;
};
